export var KEYS = {
  IS_LEGITIMATE_INTEREST: 'isLegitimateInterest',
  LEGITIMATE_INTEREST_TEXT: 'legitimateInterestPrivacyPolicyText',
  LEGITIMATE_INTEREST_SUBSCRIPTIONS: 'legitimateInterestSubscriptionTypes',
  LEGITIMATE_INTEREST_LAWFUL_BASIS: 'legitimateInterestLegalBasis',
  COMMUNICATION_CONSENT_TEXT: 'communicationConsentText',
  COMMUNICATION_CONSENT_CHECKBOXES: 'communicationConsentCheckboxes',
  IMPLICIT_PROCESSING_CONSENT_TEXT: 'implicitProcessingConsentText',
  PRIVACY_POLICY_TEXT: 'privacyPolicyText'
};
export var CHECKBOX_KEYS = {
  COMMUNICATION_TYPE_ID: 'communicationTypeId',
  LABEL: 'label'
};
export var FORMS_KEYS = {
  PROCESSING_CONSENT_TYPE: 'processingConsentType',
  PROCESSING_CONSENT_TEXT: 'processingConsentText'
};
export var IMPLICIT_PROCESSING_CONSENT_TYPE = 'IMPLICIT';
export var GDPR_COMPLIANCE_ENABLED = 'GDPRComplianceEnabled';
export var LAWFUL_BASIS_PQL = 'LEGITIMATE_INTEREST_PQL';
export var ONE_TO_ONE = 'ONE_TO_ONE';